<template>
  <v-radio-group
    class="ml-2 mt-2 mb-2"
    :error-messages="errors"
    :hide-details="dense"
    :model-value="modelValue"
    :rules="rules"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <div class="null-bool-btns">
      <v-btn
        v-for="val in [true, false]"
        :key="val.toString()"
        :color="modelValue === val ? 'primary' : undefined"
        :disabled="field.readonly"
        elevation="0"
        :ripple="false"
        @click.stop="$emit('update:modelValue', val)"
      >
        {{ val ? 'Yes' : 'No' }}
      </v-btn>
    </div>

    <v-label>
      <FieldLabel :field="field" />
    </v-label>
  </v-radio-group>
</template>

<script setup lang="ts">
defineProps<{
  field: FieldConfig
  rules?: FormRule[]
  errors?: string[]
  dense?: boolean
  modelValue: boolean | null | undefined
}>();
defineEmits(['update:modelValue']);
</script>

<style scoped lang="scss">
@import "~/assets/styles/variables";

.v-radio-group {
  &:deep(.v-selection-control-group) {
    flex-direction: row;
    align-items: center;
  }

  .v-label {
    white-space: break-spaces;
    padding-left: 1rem;
  }

  .v-btn {
    transition: none !important;
  }

  .null-bool-btns {
    display: flex;

    & > .v-btn {
      background-color: $ash-gray-300;
      &:deep(.v-btn__content) {
        text-transform: none;
      }

      &:first-child {
        border-radius: 6px 0px 0px 6px;
        margin-right: 2px;
      }

      &:last-child {
        border-radius: 0px 6px 6px 0px;
      }
    }
  }
}
</style>
